<template>
  <div class="page detail d-flex justify-center">
    <div class="detail-content">
      <h3>{{listcontes.title}}</h3>
      <p class="time">{{listcontes.createTime}}</p>
      <div class="line"></div>
      <div class="main" v-html="listcontes.content">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NewsDetail',
  data(){
    return{
      listcontes:''
    }
  },
  mounted() {
    let id = this.$route.query.id

    this.newsdatail(id)
  },
  methods:{
    newsdatail(e){
      const url = this.url.url+'/hogchain-boot/hogchain/hotchainBusNews/queryById';
      this.$http.get(url, {
        params: {
          id: e
        }
      }).then(
        response => {
          this.listcontes=response.body.result
        },

        response => {
          alert('请求失败');
        },
      );
    }
  }

}
</script>

<style lang="scss" scoped>
.detail {
  &-content {
    width: 10rem;
    padding-top: 1.225rem;
    h3 {
      font-size: 0.45rem;
      color: #4a4a4a;
      margin-bottom: 0.625rem;
    }
    .time {
      font-size: 0.175rem;
      color: #999;
      margin-bottom: 0.4rem;
    }
    .line {
      width: 100%;
      height: 0.0125rem;
      background-color: #999;
    }
    .main {
      padding-top: 0.625rem;
      .title {
        font-size: 0.225rem;
        color: #666;
        margin-bottom: 0.5rem;
      }
      p {
        line-height: 0.45rem;
        font-size: 0.175rem;
        color: #999;
      }
    }
  }
}
</style>
